export type InboundContinuePlacement = "waiting" | "holding" | "pending_put_away";

export function inboundContinueStationLabel(placement: InboundContinuePlacement): string {
  switch (placement) {
    case "waiting":
      return "Awaiting receipt";
    case "holding":
      return "Holding";
    case "pending_put_away":
      return "To stock";
  }
}

/** Station page with this arrival or carton already selected. */
export function inboundContinueStationHref(input: {
  placement: InboundContinuePlacement;
  arrivalScan?: string | null;
  inventoryBoxHex?: string | null;
}): string {
  if (input.placement === "waiting") {
    const scan = input.arrivalScan?.trim() ?? "";
    if (scan === "") return "/shipping/receive";
    return `/shipping/receive?scan=${encodeURIComponent(scan)}`;
  }
  const hex = input.inventoryBoxHex?.trim() ?? "";
  const scan = hex === "" ? "" : `/i/${hex}`;
  const path = input.placement === "holding" ? "/shipping/holding" : "/shipping/to-stock";
  if (scan === "") return path;
  return `${path}?scan=${encodeURIComponent(scan)}`;
}
